import { LogLevel } from '90.quickConnect.Models/enums';

const DEFAULT_LOG_LEVEL = LogLevel.None;

const parseLogLevel = (rawValue: string | undefined, fallback: LogLevel = DEFAULT_LOG_LEVEL): LogLevel => {
  if (!rawValue) {
    return fallback;
  }

  const parsedValue = LogLevel[rawValue as keyof typeof LogLevel];
  return parsedValue !== undefined ? parsedValue : fallback;
};

const getConfiguredLogLevel = (): LogLevel => parseLogLevel(process.env.REACT_APP_LOG_LEVEL, DEFAULT_LOG_LEVEL);

export default getConfiguredLogLevel;
